// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".banner_container[data-v-a2fea148] {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n.banner_container img[data-v-a2fea148] {\n  width: 100%;\n}\n@media (min-width: 971px) {\n.banner_container img[data-v-a2fea148] {\n    width: 970px;\n}\n}", ""]);
// Exports
module.exports = exports;
